import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FacebookRoundIcon from 'common/icons/FacebookRound';
import { colorWhite, colorFacebook } from 'common/styles/palette';
import { useDispatch } from 'react-redux';

import { notifyError } from 'common/compounds/Notification/modules';
import { useFacebookSdk, facebookLogin, facebookMe } from 'common/utils/facebookSdk';

import { FormIdContext } from '../../../FormIdContext';
import { facebookReceiveMessageEffect } from '../../../../epics/socialRsvp';

const BASE_COMPONENT_NAME = 'Facebook';
const FACEBOOK_IN_LABEL = 'Continue with Facebook';

const FacebookButton = styled.button.attrs({
    type: 'button',
})`
    display: flex;
    align-items: center;
    margin: 0 auto;
    font-family: Helvetica, Arial, sans-serif;
    background-color: ${colorFacebook};
    color: ${colorWhite};
    font-size: 1rem;
    border-radius: 4px;
    font-weight: bold;
    padding: 0.5rem 1rem;
    max-height: 2.5rem;
    border: 0;
    cursor: pointer;
`;

const FacebookIconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 1.5625rem;
    width: 1.5625rem;
`;

const FacebookIcon = styled(FacebookRoundIcon)`
    height: 100%;
`;

const FacebookLabel = styled.div`
    margin-left: 0.5rem;
`;

const Facebook = (props) => {
    const dispatch = useDispatch();
    const formId = React.useContext(FormIdContext);

    const [facebookSdk, isSdkLoading] = useFacebookSdk();

    const openFacebookModal = (e) => {
        e.preventDefault();

        if (isSdkLoading) {
            dispatch(notifyError('Something went wrong, please try again.'));
            return;
        }

        facebookLogin(facebookSdk, 'email')
            .then(facebookMe(['first_name', 'last_name', 'short_name', 'middle_name', 'email']))
            .then((data) =>
                dispatch(
                    facebookReceiveMessageEffect({
                        nodeId: props.nodeId,
                        userData: {
                            firstName: data.first_name,
                            lastName: data.last_name,
                            email: data.email,
                            facebookFacebookId: data.id,
                            facebookMiddleName: data.middle_name,
                            facebookShortName: data.short_name,
                        },
                        canSetUserData: true,
                        formId,
                    }),
                ),
            )
            .catch(() => {
                dispatch(notifyError('Something failed logging with Facebook, please try again.'));
            });
    };

    return (
        <FacebookButton
            data-qa={`${BASE_COMPONENT_NAME}__button`}
            onClick={openFacebookModal}
            aria-required={props.isRequired || undefined}
        >
            <FacebookIconWrapper>
                <FacebookIcon />
            </FacebookIconWrapper>
            <FacebookLabel>{FACEBOOK_IN_LABEL}</FacebookLabel>
        </FacebookButton>
    );
};

Facebook.propTypes = {
    isRequired: PropTypes.bool.isRequired,
    nodeId: PropTypes.string.isRequired,
};

export default Facebook;
